export default __webpack_public_path__ + "c1956ed17280c025fce0ce3b14717475.png";